/** localStorage: once per portal user id */
export function sidebarTourStorageKey(userId: string) {
  return `gt.sidebarTour.v2.${userId}`;
}
